import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {TaskService} from '../../services/task.service';
import {HttpClient} from '@angular/common/http';

@Component({
  selector: 'nf-member',
  templateUrl: './member.component.html',
  styleUrls: ['./member.component.css']
})
export class MemberComponent implements OnInit {

  selectedMember;
  @Input() memberList = [];
  userList = [];
  isLoading = false;
  total: number;
  pageIndex = 1;
  pageSize = 10;
  searchKey;
  getBoardUserList: Observable<any>;
  loadMoreData = true;
  randomUserUrl: string;
  @Input() boardId: string;
  @Output() getData: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private http: HttpClient,
    private taskService: TaskService
  ) { }

  ngOnInit(): void {
    this.loadMore();
  }

  loadMore(): void {
    if (this.loadMoreData) {
      this.randomUserUrl = this.taskService.getBoardUser(this.boardId);
      const param = {
        size: this.pageSize.toString(),
        page: this.pageIndex.toString()
      };
      this.getBoardUserList = this.http
        .get(`${this.randomUserUrl}`, {params: param})
        .pipe(map((res: any) => res))
        .pipe(
          map((list: any) => {
            return list;
          })
        );
      this.isLoading = true;
      this.getBoardUserList.subscribe(data => {
        this.isLoading = false;
        if (data) {
          const newData = data.users && data.users.data ? data.users.data : [];
          this.userList = [...this.userList, ...newData];
          if (this.pageIndex === data.users.page.totalPages) {
            this.loadMoreData = false;
            return;
          }
          this.pageIndex = data.users.page.number + 1;
        }
      });
    }
  }
  // 模糊搜索
  onMemberSearch(value: string): void {
    this.isLoading = true;
    this.pageIndex = 1;
    const param = {
      size: this.pageSize.toString(),
      page: this.pageIndex.toString(),
      searchKey: value
    };
    this.taskService.getBoardUer(this.boardId, param).subscribe((res: any) => {
      if (res) {
        this.userList = res.users ? res.users.data : [];
        this.isLoading = false;
      }
    });
  }

  selectedMemberChange() {
    if (this.selectedMember) {
      for (let item of this.memberList) {
        if (item.id == this.selectedMember.id) { // 如果当前选择用户已在列表中，则跳过本次操作
          return;
        }
      }
      this.memberList.push(this.selectedMember);
      this.submitData();
    }
  }

  removeMember(index) {
    this.memberList.splice(index, 1);
    this.submitData();
  }

  submitData() {
    this.getData.emit(this.memberList);
  }
}
